export default __webpack_public_path__ + "static/media/information--parking--g2.87609a48.png";